import React, { useContext, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { AlertContext } from '../AlertContext';
import '../css/Error.css'

const ErrorPage = () => {
  const { showAlert } = useContext(AlertContext);
  const showAlertRef = useRef(showAlert);

  useEffect(() => {
    showAlertRef.current('403 Access Denied', 'warning');
  }, []);

  return (
    <div className='container text-center'>
      <h1 className='errorh1'>You are not authorized to access this page...</h1>
      <h2 className='errorh2'>
        Please <Link className="link" to="/login">Login</Link> to continue.
      </h2>
    </div>
  );
};

export default ErrorPage;
